// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"165":"70ca013f","453":"f8bed2da","796":"1f3dd179"}[chunkId] + ".chunk.js";
};